// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hn8ZL","colMin":"styles_colMin__evNt8"};